import React from "react"

function GroupSearchResultCard({ group, onJoin }) {
  const hasPendingJoinRequest = !!group?.hasPendingJoinRequest
  const hasPendingInvite = !!group?.hasPendingInvite
  const canJoin = !hasPendingJoinRequest && !hasPendingInvite

  let actionLabel = "Join"
  if (hasPendingJoinRequest) actionLabel = "Request Pending"
  else if (hasPendingInvite) actionLabel = "Invite Pending"

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-3 shadow-sm">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="text-sm font-semibold text-gray-900 truncate">
            {group?.name || "-"}
          </p>
          <p className="text-[11px] text-gray-500 mt-0.5">
            Group ID: <span className="font-semibold text-gray-700">{group?.groupCode || "-"}</span>
          </p>
          <p className="text-[11px] text-gray-500 mt-0.5">
            Admin: <span className="font-medium text-gray-700">{group?.adminName || "-"}</span>
          </p>
          <p className="text-[11px] text-gray-500 mt-0.5">
            Members: <span className="font-medium text-gray-700">{Number(group?.membersCount || 0)}</span>
            {" | "}Type: <span className="font-medium text-gray-700 uppercase">{group?.type || "-"}</span>
          </p>
        </div>

        <button
          type="button"
          onClick={() => canJoin && onJoin?.(group)}
          disabled={!canJoin}
          className={`px-3 py-1.5 rounded-lg text-[11px] font-semibold whitespace-nowrap transition-colors ${
            canJoin
              ? "bg-sky-500 text-white hover:bg-sky-600"
              : "bg-gray-100 text-gray-500 cursor-not-allowed"
          }`}
        >
          {actionLabel}
        </button>
      </div>
      {hasPendingInvite && (
        <p className="text-[11px] text-amber-700 mt-2">
          You already have a pending invitation. Open <span className="font-semibold">My Invitations</span>.
        </p>
      )}
      {hasPendingJoinRequest && (
        <p className="text-[11px] text-sky-700 mt-2">
          Join request is waiting for admin approval.
        </p>
      )}
    </div>
  )
}

export default GroupSearchResultCard
